// Copyright (c) 2021 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>

const ISSUE_VOUCHER_RESET = 'ISSUE_VOUCHER_RESET';

const ISSUE_VOUCHER_START_LOADER = 'ISSUE_VOUCHER_START_LOADER';
const ISSUE_VOUCHER_STOP_LOADER = 'ISSUE_VOUCHER_STOP_LOADER';

const ISSUE_VOUCHER_CHANGE_CUSTOMER_FIELDS = 'ISSUE_VOUCHER_CHANGE_CUSTOMER_FIELDS';

const ISSUE_VOUCHER = 'ISSUE_VOUCHER';

const VALIDATE_BOOKSHOP_CUSTOMER_FORM = 'VALIDATE_BOOKSHOP_CUSTOMER_FORM';
const BOOKSHOP_CUSTOMER_RESET_FORM = 'BOOKSHOP_CUSTOMER_RESET_FORM';

const SET_REQUEST_STATUS = 'SET_REQUEST_STATUS';

export {
  ISSUE_VOUCHER_RESET,

  ISSUE_VOUCHER_START_LOADER,
  ISSUE_VOUCHER_STOP_LOADER,

  ISSUE_VOUCHER_CHANGE_CUSTOMER_FIELDS,

  ISSUE_VOUCHER,

  VALIDATE_BOOKSHOP_CUSTOMER_FORM,
  BOOKSHOP_CUSTOMER_RESET_FORM,

  SET_REQUEST_STATUS,
};
